/**
 * Technology Types View - Public Access
 * No permission checks - available to all users
 */

import React from 'react';
import TechnologyTypesView from '../features/hsCodeValueChain/TechnologyTypesView';

const PermissionAwareTechnologyTypesView: React.FC = () => {
  // Public access - no permission checks
  return <TechnologyTypesView />;
};

export default PermissionAwareTechnologyTypesView;
